import React from 'react';
import { TableHead, TableRow } from '@mui/material';
import { AvTableV2HeadCell } from './AvTableV2HeadCell';
import { useAvTableV2Context } from './AvTableV2Provider';

type Props = {
  tableContainerRef: React.RefObject<HTMLDivElement | null>;
  FieldFilter: any;
};
const AvTableV2Head = ({ tableContainerRef, FieldFilter }: Props) => {
  const { table } = useAvTableV2Context();
  const headers = table.getFlatHeaders();

  return (
    <TableHead sx={{ userSelect: 'none' }}>
      <TableRow>
        {headers.map(header => (
          <AvTableV2HeadCell key={header.id} header={header} ref={tableContainerRef} FieldFilter={FieldFilter} />
        ))}
      </TableRow>
    </TableHead>
  );
};

export default AvTableV2Head;
